var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-link-v2',{class:[_vm.name, `${_vm.name}__link`, { over: _vm.active }],attrs:{"url":_vm.href},nativeOn:{"mouseover":function($event){return _vm.onCardHover(true)},"mouseleave":function($event){return _vm.onCardHover(false)}}},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__thumbnail`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 2, x: 1, width: 11 },
        { size: 3, x: 1, width: 10 },
        { size: 4, x: 1, width: 8 },
      ]}},[((_vm.cms.image || {}).filename)?_c('a-image-v2',{class:[`${_vm.name}__image`, _vm.podcast ? `${_vm.name}__podcast` : ''],attrs:{"src":(_vm.cms.image || {}).filename,"alt":(_vm.cms.image || {}).alt,"layout":_vm.layout}},[(_vm.podcast)?_c('a-waveform'):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__content`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 2, x: 13, width: 12 },
        { size: 3, x: 12, width: 12 },
        { size: 4, x: 11, width: 12 },
      ]}},[(_vm.cms.eyebrow)?_c('a-eyebrow',{class:`${_vm.name}__eyebrow`,attrs:{"cms":_vm.cms}}):_vm._e(),_vm._v(" "),(_vm.cms.heading)?_c('a-heading',{class:`${_vm.name}__heading`,attrs:{"cms":_vm.cms}}):_vm._e(),_vm._v(" "),(_vm.cms.copy)?_c('div',{class:`${_vm.name}__text`,domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.cms.copy))}}):_vm._e(),_vm._v(" "),_vm._l((_vm.cms.cta),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__cta`,attrs:{"html-tag":"span","cms":item,"type":"secondary"}})})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }